import { AfterContentInit, AfterViewInit, Component, DestroyRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { Ids } from '../../../models/common/ids.model';
import { PhotographerStatusEnum } from '../../../models/common/photographer-status.enum';
import { PhotographerStatus } from '../../../models/common/photographer-status.model';
import { UpdatePhotographer } from '../../../models/company/update-photographer.models';

import { opacityAnimation } from '../../../animations/opacity.animation';
import { Photographer } from '../../../models/common/photographer.models';
import { SidebarTypeEnum } from '../../../models/common/sidebar-type.enum';
import { CompanyService } from '../../../services/company.service';
import { TopbarService } from '../../../shared/services/topbar.service';
import { UtilityFunctions } from '../../../shared/utilities/functions.models';
import { ColumnInfo } from '../../../shared/models/column-info.type';
import { FilterService } from '../../../shared/services/filter.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PhotographerService } from '../../../services/photographer.service';
import { OrdersListSchema } from '../../../models/common/orders-list-schema.model';
import { OrderListItem } from '../../../models/common/order-list-item.model';
import { ActivatedRoute, Router } from '@angular/router';
import { first, map, switchMap } from 'rxjs';
import { PhotographerStatusFilterService } from '../../../shared/services/photographer-status-filter.service';
import { MatDialog } from '@angular/material/dialog';
import { FilterDialogData } from '../../../shared/models/types/filter-dialog-data.type';
import { FilterListComponent } from '../../../shared/components/filter-list/filter-list.component';
import { AppService } from '../../../app.service';
import { WrapperResultGraphQL } from '../../../models/shared/types/wrapper-result-graphql.type';
import { GetQuery } from '../../../models/shared/enums/get-query.enum';
import { GraphQLService } from '../../../services/graph-ql.service';
import { GraphQLWrappingType } from 'graphql';

@Component({
  standalone: false,
  selector: 'bt-photographers',
  templateUrl: './photographers.component.html',
  styleUrls: ['./photographers.component.scss'],
  animations: [opacityAnimation]
})
export class PhotographersComponent implements AfterViewInit, AfterContentInit {

  @ViewChild('modalContent') modalContent: any;

  @ViewChild('menuColumn') menuColumn: any;
  @ViewChild('brandsColumn') brandsColumn: any;
  @ViewChild('discountColumn') discountColumn: any;
  @ViewChild('discountThresholdColumn') discountThresholdColumn: any;
  @ViewChild('automaticRenewalColumn') automaticRenewalColumn: any;
  @ViewChild('hiredFromColumn') hiredFromColumn: any;
  @ViewChild('hiredUntilColumn') hiredUntilColumn: any;
  @ViewChild('ordersHistoryColumn') ordersHistoryColumn: any;
  @ViewChild('montlyPaidColumn') montlyPaidColumn: any;
  @ViewChild('shotCostColumn') shotCostColumn: any;
  @ViewChild('totalPaidColumn') totalPaidColumn: any;

  readonly #destroyRef = inject(DestroyRef);
  readonly #filterService = inject(FilterService);
  readonly #appService = inject(AppService);
  readonly #graphQLService = inject(GraphQLService);
  readonly #router = inject(Router);
  readonly #dialog = inject(MatDialog);
  readonly #activatedRoute = inject(ActivatedRoute);

  showModal = false;

  filtersList = [
    { id: 'photographerStatus', label: 'Photographer Status' },
  ];

  photographerStatus: FilterDialogData<PhotographerStatus> = {
    title: 'Photographer Status',
    selected: [],
    filterService: inject(PhotographerStatusFilterService)
  };

  columns: Array<ColumnInfo> = [];

  chips: Array<any> = [];
  currentSidebar: SidebarTypeEnum;
  sidebarType = SidebarTypeEnum;

  tmpPhotog: Photographer;
  photographers: { data?: Array<Photographer>, paginationPage?: number, paginationSize: number, searchText?: string, areFiltered?: boolean } = { searchText: '', paginationSize: 20 };
  photographersLoaderId = 'photographersLoaderId';

  photographerOrders: OrdersListSchema<OrderListItem> = { orders: [], total: 0 };

  constructor(
    private topbarService: TopbarService,
    //private companyService: CompanyService
  ) {
    this.searchTextSubscription();
    this.queryParamsSubscribe();
  }

  ngAfterViewInit(): void {
    this.columns = [
      { title: '', width: '3%', key: 'action', template: this.menuColumn },
      { title: 'Nome', width: '10%', key: 'fullName' },
      { title: 'Inizio Contratto', width: '7%', key: 'hiredFrom', template: this.hiredFromColumn },
      { title: 'Scadenza Contratto', width: '7%', key: 'hiredUntil', template: this.hiredUntilColumn },
      { title: 'Status', width: '5%', key: 'statusName' },
      { title: 'Storico Ordini', width: '5%', key: 'ordersHistory', template: this.ordersHistoryColumn },
      { title: 'Brands', width: '18%', key: 'brandColumn', template: this.brandsColumn },
      { title: 'Costo per Shot', width: '5%', key: 'shotCost', template: this.shotCostColumn },
      { title: 'Totale Pagato', width: '5%', key: 'totalPaid', template: this.totalPaidColumn }
    ];
  }

  public ngAfterContentInit(): void {
    //Acquisizione dei parametri dell'url
    this.getData();
  }

  clearFilter(event: any, filter: string): void {
    event.stopPropagation();
    this[filter].selected = [];
    (this[filter] as FilterDialogData<any>).filterService.clearSelection();
    this.#filterService.removeDataFromUrl(filter, () => null);
  }

  getData() {
    const params = this.#filterService.getDataFromUrl();

    if (params['search']) {
      this.photographers.searchText = params['search'];
      this.chips.unshift({ 'search': params['search'] })
    }

    if (params['photographerStatus']) {
      const selectedStatus = params['photographerStatus'].split('-').map(el => +el);
      this.#graphQLService.getData<PhotographerStatus>(GetQuery.GET_PHOTOGRAPHER_STATUS, { statusIds: selectedStatus })
        .pipe(takeUntilDestroyed(this.#destroyRef), map((res: any) => res['data']['photographerStatus']))
        .subscribe({
          next: (data) => {
            this.photographerStatus.selected = data.nodes.map(el => ({ ...el, disabled: false, selected: true, displayId: el.id, displayName: el.name }));
          }
        });
    }
  }

  applyFilters(filter: string, selected: Array<any>) {
    if (!selected.length) {
      // Rimozione il parametro dall'url
      this.#filterService.removeDataFromUrl(filter, () => null);
    } else {
      this[filter].selected = selected;
      const ids = selected.map(el => `${el.displayId}`).join('-');
      this.#filterService.setQueryParams({ [filter]: ids });
    }
  }

  public onItemAction(item: Photographer, sidebarType: SidebarTypeEnum) {
    item.showMenu = false;
    this.currentSidebar = sidebarType;
    this.tmpPhotog = UtilityFunctions.DeepClone(item);
  }

  private getPhotographers(page: number, params?: { [key: string]: string }) {
    this.photographers.paginationPage = page;
    const filters = {
      companyId: this.#appService.companyId,
      paginationPage: page,
      paginationSize: this.photographers.paginationSize,
      search: '',
      statusIds: (params && params['photographerStatus']) ? params['photographerStatus'].split('-').map(el => new Ids(+el)) : this.photographerStatus.selected.map(el => new Ids(el.displayId)),
      photographerIds: [],
    };

    this.#graphQLService.getData<Photographer>(GetQuery.GET_PHOTOGRAPHERS, filters)
      .pipe(takeUntilDestroyed(this.#destroyRef), map((res: any) => res['data']['photographers']))
      .subscribe((data: WrapperResultGraphQL<Photographer>) => {
        this.photographers.data = data.nodes.map(el => ({ ...el }));
      });
  }

  parseDate(str: string): Date {
    const [datePart, timePart] = str.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  public inViewportAction(ev: any, item: Photographer) {
    item.isVisible = ev.isVisible;
    if (item.isVisible) {
      const index = this.photographers.data.findIndex(el => el.personId === item.personId);
      if (index === this.photographers.data.length - 1 && this.photographers.data.length / this.photographers.paginationSize === this.photographers.paginationPage + 1) {
        this.getPhotographers(this.photographers.paginationPage + 1);
      }
    }
  }

  public savedInfo() {
    this.tmpPhotog = null;
    this.currentSidebar = null;
    this.getPhotographers(0);
  }

  public createdCustomOrder() {
    this.tmpPhotog = null;
    this.currentSidebar = null;
  }

  // public onSelectStatus(selectedStatus: Array<PhotographerStatus>) {
  //   this.status.cachedSelections = selectedStatus;
  //   this.getPhotographers(0);
  // }

  public deletePhotographer() {
    /*
    const updatePhotographer = new UpdatePhotographer({
      PhotographerId: this.tmpPhotog.personId,
      DiscountPercentage: null,
      DiscountThreshold: null,
      EndDate: null,
      StartDate: null,
      MaxItems: null,
      ShotCost: null,
      StatusId: PhotographerStatusEnum.Deleted,
      AutomaticRenewal: false,
      BrandIdCategoryId: []
    });
    this.companyService.updatePhotographer(updatePhotographer, this.photographersLoaderId)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => {
        const index = this.photographers.data.findIndex(p => p.personId === this.tmpPhotog.personId);
        this.tmpPhotog = null;
        if (index >= 0) this.photographers.data.splice(index, 1);
      });*/
  }

  // public onOpenFilters() {
  //   this.currentSidebar = SidebarTypeEnum.filters;
  //   this.status.currentSelections = UtilityFunctions.DeepClone(this.status.cachedSelections);
  // }


  openDialogFilter(title: string = ''): void {
    const initialValue = [...this[title].selected];
    const dialog = this.#dialog.open(FilterListComponent<PhotographerStatus>, {
      data: { title: this[title].title, selected: this[title].selected, filterService: this[title].filterService, variables: this[title].variables },
      height: '70%',
      width: 'auto',
      minWidth: '25%'
    });

    dialog.afterClosed()
      .subscribe({
        next: (res) => {
          if (res) {
            this.applyFilters(title, res)
            this[title].selected = initialValue;
          }
        }
      })
  }

  getLabel(filter: string): string {
    return this[filter].selected.length ? `: ${this[filter].selected.map(el => el.displayName).join(', ').slice(0, 20)}` : '';
  }

  getFullTitleFilter(filter: string): string {
    return this[filter].selected.length ? `${this[filter].selected.map(el => el.displayName).join(', ')}` : '';
  }

  // openModal() {
  //   this.status.currentSelections = UtilityFunctions.DeepClone(this.status.cachedSelections);
  //   // this.modalType = 'filters';
  //   this.showModal = true;
  // }

  closeModal() {
    this.showModal = false;
  }

  openOrdersHistory(photographerId: number) {
    const url = this.#router.serializeUrl(
      this.#router.createUrlTree(['/company/photographer-orders', photographerId])
    );
    window.open(url, '_blank');
  }

  // public onExitFilters() {
  //   this.currentSidebar = null;
  //   this.status.currentSelections = null;
  // }


  private searchTextSubscription() {
    this.topbarService.searchTextSubscribe
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: data => {
          if (data !== this.photographers.searchText && !this.tmpPhotog) {
            this.photographers.searchText = data;

            // Gestione search chip e URL
            const params: Array<{ [key: string]: string }> = [{ 'search': data }];
            this.chips.find(el => el.search) ? this.chips.find(el => el.search).search = data : this.chips.unshift({ 'search': data });
            this.#filterService.addDataToUrl(params);

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        },
        error: error => console.error('Error in searchTextSubscription:', error)
      });
  }

  private queryParamsSubscribe() {
    this.#activatedRoute.queryParams
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(data => {
        this.getData();
        this.getPhotographers(0, data);
      });
  }

  getBrandColumnValue(photographer: Photographer): string {
    let brandLabel = ''
    if (photographer.brands && photographer.brands?.length > 0) {
      const brands = photographer.brands.map(el => {
        const categories = el.categories.map(cat => cat.categoryName);
        return `${el.brandName} - ${categories.length ? categories.join(', ') : 'All Categories'}`
      });

      brandLabel = brands.join(', ');
    }

    return brandLabel;
  }
}
